import type { IconView } from './types.ts';
import { esc } from './util.ts';

/** Every choice has a cover while its optional image loads, including when that image is unavailable. */
export function packageCoverHtml(name: string, icon?: IconView): string {
  const colors = ['#394d83', '#635083', '#32746b', '#8b5843', '#775a83', '#3c687b'];
  const hash = Array.from(name).reduce((value, char) => (value + char.codePointAt(0)!) % colors.length, 0);
  const words = name.split(/[-_.\s]+/).filter(Boolean);
  const initials = (words.length > 1 ? words.slice(0, 2).map(word => Array.from(word)[0]).join('') : Array.from(name).slice(0, 2).join('')).toUpperCase();
  const glyph = icon?.kind === 'preset' ? icon.glyph : initials || 'S';
  const color = icon?.kind === 'preset' ? icon.color : colors[hash]!;
  return `<span class="skill-cover" aria-hidden="true" style="--cover-color:${esc(color)}"><span>${esc(glyph)}</span>${icon?.kind === 'image' ? `<img src="${esc(icon.url)}" alt="" loading="lazy" referrerpolicy="no-referrer">` : ''}</span>`;
}

export function enableCoverFallbacks(root: HTMLElement): void {
  root.querySelectorAll<HTMLImageElement>('.skill-cover img').forEach(image => {
    image.onerror = () => image.remove();
    if (image.complete && image.naturalWidth === 0) image.remove();
  });
}
